import { render, staticRenderFns } from "./ConfigureTasks.vue?vue&type=template&id=47047198&scoped=true"
import script from "./ConfigureTasks.vue?vue&type=script&lang=ts"
export * from "./ConfigureTasks.vue?vue&type=script&lang=ts"
import style0 from "./ConfigureTasks.vue?vue&type=style&index=0&id=47047198&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47047198",
  null
  
)

export default component.exports